import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderSupplySubContractDetail extends BaseModelAPI {
	static entity = 'workordersupplysubcontractdetail';
	static entityName = 'workordersupplysubcontractdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderSupplySubContractId = '';
			this.workOrderSupplySubContract = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.qtyOutstanding = 0;
			this.stockVendor = 0;
			this.suggestQty = 0;
			this.actualQty = 0;
			this.uoM = '';
			this.remarks = '';
			this.actualQtyPicking = 0;
			this.purchaseOrderDetailId = 0;
			this.qtyPo = 0;
			this.partSubcontId = '';
			this.partSubcont = {};
			this.partMappingSubcontId = '';
			this.partMappingSubcont = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}